import React, { Component } from 'react';
import {
  View,
  Text
} from 'react-native-web';
import Webcam from "react-webcam";
import constants from '../global-constants.jsx';
import FreqFinder from '../frequency-finder.jsx';


export default class Camera extends Component {

  constructor() {
    super();
    this.state = {
      result: "none",
      imageSrc: null
    };
    this._camera = null;
  }

  componentDidMount() {
    this.initializeFreqFinder();
  }

  componentWillUnmount() {
    console.log("unmounting");
    constants.freqfinder.stop();
  }

  initializeFreqFinder() {
    constants.freqfinder = new FreqFinder();
    constants.freqfinder.action = (note) => {
      let newState = this.state;
      if (this.old_note !== "none" && note === "none") {
        console.log("activated");
        if (this._camera !== null) {
          newState.imageSrc = this._camera.getScreenshot();
        } else {
          newState.imageSrc = null;
        }
      }
      this.old_note = note;
      newState.result = note;
      this.setState(newState);
    }
    constants.freqfinder.start(400);
  }

  render() {
    if (this.state.imageSrc !== null) {

      return (
        <View style={{ flex: 1 }}>
          <Text></Text>
          <Text>{this.state.result}</Text>
          <img
            style={{ width: 'auto', height: '90vh', objectFit: 'contain' }}
            src={this.state.imageSrc}
          />
        </View>);
    }

    return (
      <View style={{ flex: 1 }}>
        <Text></Text>
        <Text>{this.state.result}</Text>
        <View style={{ height: '90vh', width: '100%' }}>
          <Webcam videoConstraints={{
            facingMode: "user"
          }}
            ref={ref => {
              this._camera = ref;
            }}
          />
        </View>
      </View>);
  }
}
